import axios from "axios";
import apiURI from "./Api";

const HttpClient = ({ token }) => {
  return axios.create({ baseURL: apiURI, headers: { Authorization: `Bearer ${token}` } });
};

export default HttpClient;
